
import {fetchWithState, getFetchedJSON} from '~/misc/fetch';
import get from 'lodash/get';
import max from 'date-fns/max';
import min from 'date-fns/min';
import startOfDay from 'date-fns/start_of_day';
import endOfDay from 'date-fns/end_of_day';
import format from 'date-fns/format';
import toLegacyLoad from '~/misc/toLegacyLoad';
import * as equipment from '~/misc/equipment';

const markCreatedAt = (since) => {
  const searchSince = new Date(since);
  return (item) => {
    const createdAt = item.created_at || (searchSince - item.age);
    return toLegacyLoad(item, createdAt);
  };
};

const getRequest = (data, getState) => {
  const origin = getState().geosearch['alert:origin-field'];
  const destination = getState().geosearch['alert:destination-field'].selected;
  const state = [];
  const city = [];
  destination.forEach(element => {
    if (element.placeValue.is_city) {
      city.push({
        lng: element.placeValue.lng,
        lat: element.placeValue.lat,
        deadhead: Number(data.dhd) || 200,
        address: element.placeValue.name
      })
    } else if (element.placeValue.state) {
      state.push(element.placeValue.state)
    }
  });
  let to_location = {};
  if (state.length === 0 && city.length === 0) {
    to_location = null;
  } else{
    if (state.length > 0) {
      to_location.state = state;
    }
    if (city.length > 0) {
      to_location.city = city;
    }
  }
  return {
    user_id: getState().user.id,
    length: data.length,
    load_size: data.loadSize,
    weight_max: data.weight,
    pickup_start: format(startOfDay(min(data.date[0])), 'YYYY-MM-DDTHH:mm:ss'),
    pickup_end: format(endOfDay(max(data.date[data.date.length - 1])), 'YYYY-MM-DDTHH:mm:ss'),
    from_location: {
      address: origin.placeValue.name,
      lng: origin.placeValue.lng || 0,
      lat: origin.placeValue.lat || 0,
      deadhead: Number(data.dho) || 200
    },
    to_location,
    equipment: data.equipment[0] ? equipment.idToHuman[data.equipment[0]].toLocaleLowerCase() : 'all'
  }
}


const getRequestWithLocation = (data, getState) => {
  const origin = data.origin;
  const destination = data.destination
  const state = [];
  const city = [];

  let to_location = {}; 
  if(destination.name) {
    to_location.city = [{
      address: destination.name,
      lng: destination.lng || 0,
      lat: destination.lat || 0,
      deadhead: Number(data.dhd) || 200
    }]
  }else {
    to_location = null
  }
  return {
    user_id: getState().user.id,
    length: data.length,
    load_size: data.loadSize,
    weight_max: data.weight,
    pickup_start: format(startOfDay(min(data.date[0])), 'YYYY-MM-DDTHH:mm:ss'),
    pickup_end: format(endOfDay(max(data.date[data.date.length - 1])), 'YYYY-MM-DDTHH:mm:ss'),
    from_location: {
      address: origin.name,
      lng: origin.lng || 0,
      lat: origin.lat || 0,
      deadhead: Number(data.dho) || 200
    },
    to_location,
    equipment: data.equipment[0] ? equipment.idToHuman[data.equipment[0]].toLocaleLowerCase() : 'all'
  }
}

export const addAlert = (getState, data) => {
  return fetchWithState(getState, {
    url: '/v1/search/shipments/alert/',
    method: 'POST',
    body: getRequest(data, getState),
  }, false).then(getFetchedJSON)
}

export const addAlertFromOtherWhere = (getState, data) => {
  return fetchWithState(getState, {
    url: '/v1/search/shipments/alert/',
    method: 'POST',
    body: getRequestWithLocation(data, getState),
  }, false).then(getFetchedJSON)
}

export const changeEquipmentApi = (getState, val) => {
  return fetchWithState(getState, {
    url: '/v1/search/shipments/alert/pushAvailable',
    method: 'PATCH',
    body: val,
  }, false)
}

export const updateAlert = (getState, data, id, enabled) => {
  const lastData = getRequest(data, getState);
  lastData.enabled = enabled;
  return fetchWithState(getState, {
    url: `/v1/search/shipments/alert/${id}`,
    method: 'PATCH',
    body: lastData,
  }, false).then(getFetchedJSON)
}

export const deleteAlert = (getState, id) => {
  return fetchWithState(getState, {
    url: '/v1/search/shipments/alert/delete/' + id,
    method: 'POST',
  }, false);
}

export const getAllAlerts = (getState, type) => {
  return fetchWithState(getState, {
    url: type ? ('/v1/search/shipments/alert/?equipment=' + type.equipment) : '/v1/search/shipments/alert/',
    method: 'GET',
  }, false).then(getFetchedJSON)
}

export const getAlertLoads = (getState, id, equipment) => {
  return fetchWithState(getState, {
    url: `/v1/search/shipments/alert/${id}?q=1&equipment=${equipment}`,
    method: 'GET',
  }, false).then(getFetchedJSON).then((response) => ({
    shipments: response.items && response.items
      .filter(item => item)
      .map(markCreatedAt(response.search_since)),
    total_shipments: get(response, 'meta.total'),
    search_since: response.search_since,
  }));
}

export const changeAlertStatus = (getState, id, data) => {
  return fetchWithState(getState, {
    url: `/v1/search/shipments/alert/${id}`,
    method: 'PATCH',
    body: data,
  }, false).then(getFetchedJSON)
}

export const clearMathesApi = (getState, idList) => {
  return fetchWithState(getState, {
    url: '/v1/search/shipments/alert/clear/read',
    method: 'PATCH',
    body: idList,
  }, false)
}



// WEBPACK FOOTER //
// ./src/api/alert.js